import { Company } from "./company.model"

export class GlobalConfig{
    public id?:number
    public fuel?:string
    public distance?:string
    public cash?:string
}